var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfflineCloud = function SvgOfflineCloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 2.3c-.4-.4-1-.5-1.4-.1-.4.4-.5 1-.1 1.4l12 14c.4.4 1 .5 1.4.1.4-.4.5-1 .1-1.4l-12-14zM0 10c0-1.7.8-3.2 2.1-4.1L10 15H5c-2.8 0-5-2.2-5-5zM20 11c0 2-1.4 3.6-3.3 3.9L6.3 3.1c.9-.7 2-1.1 3.2-1.1 2.9 0 5.3 2.3 5.5 5.1.3-.1.7-.1 1-.1 2.2 0 4 1.8 4 4z"
  })));
};
export default SvgOfflineCloud;